import { render, staticRenderFns } from "./NotificacaoPenalidade2024.vue?vue&type=template&id=8392f058"
import script from "./NotificacaoPenalidade2024.vue?vue&type=script&lang=js"
export * from "./NotificacaoPenalidade2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports